var pt_br = {
    values: {
        SISP: 'SIP',
        URL: 'URL',
        'BOP Test Id on SIP': 'Id do teste no SIP',
        'API Token': 'Token da API',
        'Session token': 'Token de sessão',
        'Send to': 'Enviar para o',
        'Choose the well related with the test': 'Escolha o poço referente ao teste',
        'Choose the SIP type test': 'Escolha o tipo de teste SIP',
        'Error loading well list': 'Erro ao carregar a lista de poços',
        'Loading wells': 'Carregando poços',
        Send: 'Enviar',
        'Intervention name': 'Nome da intervenção',
        'Test successfully sent': 'Teste enviado com sucesso',
        'Tests successfully sent': 'Testes enviados com sucesso',
        'Test sent': 'Teste enviado',
        'There was a problem sending the data': 'Houve um problema ao enviar os dados',
        'Try again': 'Tentar novamente',
        Message: 'Mensagem',
        Loading: 'Carregando',
        'SIP Types': 'Tipos SIP',
        'Only my tests': 'Mostrar meus',
        'Same type tests': 'Testes do mesmo tipo',
        'Tests not sended:': 'Testes não enviados:',
        'Select tests to send': 'Selecione os testes que deseja agrupar',
        Failed: 'Falhou',
        Passed: 'Passou',
        Done: 'Concluído',
        'Join other test to send': 'Adicionar outros testes para o envio',
        'Group indentifier': 'Identificador de grupo',
        'Need to register at least one test with "group" propertie as TRUE at the sip configuration json':
            'É necessário registrar pelo menos um teste com propriedade de "group" como TRUE na configuração sip json        ',
        'Tests sended with errror': 'Testes com erro',
        Auth: 'Autenticação',
        User: 'Usuário',
        Password: 'Senha',
        'Client ID': 'Id do Cliente',
        Connection: 'Conexão',
        'SIP Configuration': 'Configurações do SIP'
    }
}

module.exports = pt_br
